import clsx from "clsx";
import { useEffect, useMemo, useState } from "react";
import { createPortal } from "react-dom";

import { Badge, HyphenIcon } from "@transfr-inc/dashboard-components";
import { Product } from "@transfr-inc/dashboard-components/constants";
import { Button } from "@transfr-inc/dashboard-components/forms";

import { EditCareersModal } from "@views/classrooms/details/components/menu-builder/modals/edit-careers/edit-careers.modal.jsx";
import { ActivityLogModal, ResetMenuModal } from "@views/classrooms/details/components/menu-builder/modals/index.js";

import "./ce-menu-builder.header.scss";

export const CeMenuBuilderHeader = ({
  simulations,
  mergedSimulations,
  className,
  classroom,
  onResetMenu,
  onEditSimulations,
  readOnly,
}) => {
  const [actionsDisabled, setActionsDisabled] = useState();
  const [openEditCareersModal, setOpenEditCareersModal] = useState();
  const [openCeResetMenuModal, setOpenCeResetMenuModal] = useState();
  const [openActivityLogModal, setOpenActivityLogModal] = useState();

  const simulationsCount = useMemo(() => simulations?.length, [simulations]);

  const onEditSimulationsHandler = (simulations, oldSimulations) => {
    return onEditSimulations(simulations, oldSimulations).finally(() =>
      setOpenEditCareersModal()
    );
  };

  useEffect(() => {
    setActionsDisabled(!mergedSimulations);
  }, [mergedSimulations]);

  const onActivityLogHandler = () => {
    setOpenActivityLogModal(true);
  };

  const onResetMenuHandler = () => {
    return onResetMenu().then(() => setOpenCeResetMenuModal());
  };

  return (
    <>
      <div className={clsx("menu-builder-header", className)}>
        <div className="left-section">
          <h2>Careers</h2>
          <Badge value={simulationsCount ?? <HyphenIcon />} />
          {!readOnly && (
            <>
              <Button
                icon={["fa-regular", "pen-to-square"]}
                onClick={() => setOpenEditCareersModal(true)}
                disabled={actionsDisabled}
                tooltip="Edit Careers"
              />
            </>
          )}
        </div>
        <div className="right-section">
          {!readOnly && (
            <Button
              icon={["fa-regular", "clock-rotate-left"]}
              onClick={() => setOpenCeResetMenuModal(true)}
              disabled={actionsDisabled}
            >
              Reset to Default
            </Button>
          )}
          <Button
            icon={["fa-regular", "list-timeline"]}
            onClick={() => onActivityLogHandler()}
            disabled={actionsDisabled}
          >
            Activity Log
          </Button>
        </div>
      </div>
      {createPortal(
        <ActivityLogModal
          open={openActivityLogModal}
          onClose={() => setOpenActivityLogModal()}
          classroom={classroom}
          async
        ></ActivityLogModal>,
        document.body
      )}
      {createPortal(
        <EditCareersModal
          open={openEditCareersModal}
          onClose={() => setOpenEditCareersModal()}
          simulations={mergedSimulations}
          onApplyChanges={onEditSimulationsHandler}
          async
        />,
        document.body
      )}
      {createPortal(
        <ResetMenuModal
          open={openCeResetMenuModal}
          onClose={() => setOpenCeResetMenuModal()}
          onConfirmReset={onResetMenuHandler}
          product={Product.CE}
          async
        />,
        document.body
      )}
    </>
  );
};
